import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { EnumHelper } from "../../../../helpers/EnumHelper";
import { useTranslation } from "react-i18next";

const CategoryOfFixedAssetDetailMain = () => {
  const {t} = useTranslation()
  return (
    <>
      <Row>
        <Col sm={9}>
          <NFTextInput title={t("Description")} fieldName={"description"} required />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("Code")} fieldName={"code"} disabled />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupInput title={t("AccountingAccount")} fieldName={"accountingAccount"} items={EnumHelper.CategoryOfFixedAssetTestTypeEnum()} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupInput title={t("DepreciationAccount")} fieldName={"depreciationAccount"} items={EnumHelper.CategoryOfFixedAssetTestTypeEnum()} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupInput title={t("ExpensesAccount")} fieldName={"expensesAccount"} items={EnumHelper.CategoryOfFixedAssetTestTypeEnum()} />
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <NFLookupInput title={t("DepreciationMethod")} fieldName={"depreciationMethod"} items={EnumHelper.CategoryOfFixedAssetTestTypeEnum()} required />
        </Col>
      </Row>
      <Row>
        <Col sm={3}>
          <NFTextInput title={t("UsefulLife(mon)")} fieldName={"usefulLifeMon"} />
        </Col>
        <Col sm={3}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
      </Row>
    </>
  );
};

export default CategoryOfFixedAssetDetailMain;
